import type { CognitoMfaChallengeStep } from './WorkyPendingMfaChallengeInterfaces';
import { CognitoSignUpFailureType } from './WorkySignUpFailureInterfaces';

interface CognitoSignInWithPasswordRequest {
    readonly emailAddress: string;
    readonly password: string;
}

interface CognitoAuthTokensResult {
    readonly accessToken: string;
    readonly idToken: string;
    readonly refreshToken: string;
    readonly expiresInSeconds?: number;
}

interface CognitoExistingSessionResult {
    readonly tokens: CognitoAuthTokensResult;
    readonly signedInEmailAddress: string;
}

enum CognitoSignInOutcomeType {
    TOKENS = 'TOKENS',
    MFA_REQUIRED = 'MFA_REQUIRED',
    NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
    EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED',
    FAILURE = 'FAILURE',
}

interface CognitoSignInTokensOutcome {
    readonly outcomeType: CognitoSignInOutcomeType.TOKENS;
    readonly tokens: CognitoAuthTokensResult;
}

interface CognitoSignInMfaRequiredOutcome {
    readonly outcomeType: CognitoSignInOutcomeType.MFA_REQUIRED;
    readonly emailAddress: string;
    readonly mfaChallengeStep: CognitoMfaChallengeStep;
}

interface CognitoSignInNewPasswordRequiredOutcome {
    readonly outcomeType: CognitoSignInOutcomeType.NEW_PASSWORD_REQUIRED;
    readonly emailAddress: string;
}

interface CognitoSignInEmailNotVerifiedOutcome {
    readonly outcomeType: CognitoSignInOutcomeType.EMAIL_NOT_VERIFIED;
    readonly emailAddress: string;
}

interface CognitoSignInFailureOutcome {
    readonly outcomeType: CognitoSignInOutcomeType.FAILURE;
    readonly errorMessage: string;
}

type CognitoSignInOutcome =
    | CognitoSignInTokensOutcome
    | CognitoSignInMfaRequiredOutcome
    | CognitoSignInNewPasswordRequiredOutcome
    | CognitoSignInEmailNotVerifiedOutcome
    | CognitoSignInFailureOutcome;

interface CognitoSignUpRequest {
    readonly emailAddress: string;
    readonly password: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly phoneNumber: string;
}

interface CognitoConfirmSignUpRequest {
    readonly emailAddress: string;
    readonly confirmationCode: string;
}

interface CognitoSignUpFailureResult {
    readonly failureType: CognitoSignUpFailureType;
    readonly errorMessage: string;
}

interface CognitoConfirmPasswordResetRequest {
    readonly emailAddress: string;
    readonly confirmationCode: string;
    readonly newPassword: string;
}

interface CognitoPasswordResetFailureResult {
    readonly errorMessage: string;
}

export type {
    CognitoAuthTokensResult,
    CognitoConfirmPasswordResetRequest,
    CognitoConfirmSignUpRequest,
    CognitoExistingSessionResult,
    CognitoPasswordResetFailureResult,
    CognitoSignInEmailNotVerifiedOutcome,
    CognitoSignInFailureOutcome,
    CognitoSignInMfaRequiredOutcome,
    CognitoSignInNewPasswordRequiredOutcome,
    CognitoSignInOutcome,
    CognitoSignInTokensOutcome,
    CognitoSignInWithPasswordRequest,
    CognitoSignUpFailureResult,
    CognitoSignUpRequest,
};
export { CognitoSignInOutcomeType, CognitoSignUpFailureType };
